import { useEffect, useState } from "react";
import SangatiDetailsGraph from "../../components/graphs/SangatiDetailsGraph"; // Use the real graph component
import { useLocation, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { api } from "../../utils/apiHandler";
import { useMode } from "../../context/useMode";
import DownArrowIcon from '../../../public/icons/downarrow.svg?react';

// const yDataArray = [
//   [0, 6, 16, 31, 34, 23, 13, 8], // Extraversion
//   [0, 6, 16, 31, 34, 23, 13, 8], // Agreeableness
//   [0, 6, 16, 31, 34, 23, 13, 8], // Comfort Zone
//   [0, 6, 16, 31, 34, 23, 13, 8], // Rule Abiding
//   [0, 6, 16, 31, 34, 23, 13, 8], // Stability
// ];

const GraphDetailsLight = () => {
  const { setMode } = useMode();

  const handlelightnav = () => {
    setMode("light");
    navigate("/questionnaire");
  };

  const { t } = useTranslation();
  const [openIndex, setOpenIndex] = useState(null);
  const navigate = useNavigate();
  const location = useLocation();
  const showCompatibility = location.state?.showCompatibility;
  const userLightData = location.state?.UserLightData;
  const matcheeLightData = location.state?.MatcheeLightData;

  const graphs = t("graphsLight", { returnObjects: true });

  const [yDataArray, setYDataArray] = useState([]);

  const getDarkData = async () => {
    try {
      const res = await api.get("/domain_statistics?mode=light");
      const responseData = res.data;

      const traits = [
        "extraversion",
        "agreeableness",
        "comfort_zone",
        "rule_abiding",
        "stability",
      ];

      const processedData = traits.map((trait) => {
        const traitData = responseData[trait] || {};
        const yValues = Array.from(
          { length: 105 },
          (_, i) => traitData[i.toString()] ?? 0,
        );
        return yValues;
      });

      setYDataArray(processedData);
    } catch (error) {
      console.error("Error fetching data:", error);
    }
  };

  useEffect(() => {
    getDarkData();
  }, []);

  return (
    <div className="p-3 bg-bg-grey min-h-screen">
      <div className="flex justify-between items-center mb-3">
        <div onClick={handlelightnav}>
          <img src="/icons/Sangati/Editgreen.svg" alt="" />
        </div>
        <div onClick={() => navigate(-1)}>
          <img src="/icons/backbtn.svg" className=" p-2" alt="Back" />
        </div>
      </div>

      {graphs.map((graph, index) => {
        const isOpen = openIndex === index;

        return (
          <div
            key={index}
            className="p-4 mb-2 rounded-[10px] border-div  bg-white85 text-black max-w-md mx-auto"
          >
            <div
              className="flex justify-between items-center cursor-pointer"
              onClick={() => setOpenIndex(isOpen ? null : index)}
            >
              <h2 className="text-14">{graph.title}</h2>
              <DownArrowIcon
                role="img"
                aria-label={isOpen ? t('collapse') : t('expand')}
                className={`transition-transform duration-300 ${isOpen ? 'rotate-180' : ''}`}
                style={{ color: "black85" }}
                tabIndex={0}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    setOpenIndex(isOpen ? null : index);
                  }
                }}
                onClick={() => setOpenIndex(isOpen ? null : index)}
              />
            </div>

            <div
              className={`transition-all duration-1500 ease-in-out overflow-hidden ${
                isOpen
                  ? "max-h-[300px] opacity-100 translate-y-0"
                  : "max-h-0 opacity-0"
              }`}
            >
              <p className="text-12 mt-2">{graph.description}</p>
            </div>

            <div className="relative">
              <SangatiDetailsGraph
                isOpen={isOpen}
                graphYdata={yDataArray[index]}
                showCompatibility={showCompatibility}
                userPositionValue={userLightData?.[index]}
                matcheePositionValue={matcheeLightData?.[index]}
                horizontalLineColor="#1D304D"
                gradientColors={[
                  { offset: 0, color: "#1D304D" },
                  { offset: 1, color: "#8E0017" },
                ]}
              />
            </div>
            <div
              className="flex justify-between text-sm p-1 -mt-2"
              style={{ display: "flex", justifyContent: "space-between" }}
            >
              <span>{graph.leftLabel}</span>
              <span>{graph.rightLabel}</span>
            </div>

            <div
              className={`transition-all duration-1500 ease-in-out overflow-hidden ${
                isOpen
                  ? "max-h-[1000px] opacity-100 translate-y-0"
                  : "max-h-0 opacity-0"
              }`}
            >
              <div className="mt-4 flex justify-between gap-4 text-sm">
                <div className="w-1/2 relative border-div rounded-[10px] bg-bg-grey text-black p-2 text-left">
                  <ul className="list-disc list-inside px-1 pt-2 mt-1 text-12">
                    {graph.leftTraits.map((trait, idx) => (
                      <li key={idx}>{trait}</li>
                    ))}
                  </ul>
                  <div className="absolute -top-3 left-5">
                    <img src="/icons/Sangati/eyelight.svg" alt="" />
                  </div>
                </div>

                <div className="w-1/2 relative border-div rounded-[10px] bg-bg-grey text-black p-2 text-left">
                  <ul className="list-disc list-inside text-12 px-1 pt-2 mt-1">
                    {graph.rightTraits.map((trait, idx) => (
                      <li key={idx}>{trait}</li>
                    ))}
                  </ul>
                  <div className="absolute -top-3 right-5">
                    <img src="/icons/Sangati/eyelight.svg" alt="" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        );
      })}
    </div>
  );
};

export default GraphDetailsLight;
